import { Select as AntdSelect, type SelectProps } from "antd";
import React from "react";
import styles from "./Select.module.css";

type CustomSelectType = React.FC<SelectProps> & {
  Option: typeof AntdSelect.Option;
  OptGroup: typeof AntdSelect.OptGroup;
};

export const Select: CustomSelectType = (props) => {
  return (
    <AntdSelect
      {...props}
      className={`${styles.select} ${props.className || ""}`}
    />
  );
};

Select.Option = AntdSelect.Option;
Select.OptGroup = AntdSelect.OptGroup;

export default Select;
